import { Icon, PrimaryButton, Stack, Text } from '@fluentui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export const ScreenNotAvailable = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Stack
        horizontalAlign="center"
        verticalAlign="center"
        verticalFill
        tokens={{ childrenGap: 24 }}
        styles={{ root: { height: '100%', minHeight: 280 } }}
    >
      <Icon
          iconName="Warning"
          styles={{ root: { fontSize: 56, height: 56, width: 56, color: '#a4262c' } }}
      />
      <Stack tokens={{ childrenGap: 8 }} horizontalAlign="center">
        <Text variant="xLarge">{t('Permisos insuficientes')}</Text>
        <Text variant="medium" styles={{ root: { textAlign: 'center', maxWidth: 420 } }}>
          {t('Lo sentimos, pero no tienes los permisos suficientes para ver el contenido de esta página')}
        </Text>
      </Stack>
      <PrimaryButton text={t('Ir al inicio')} onClick={() => navigate('/')} />
    </Stack>
  );
};